import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import "react-phone-input-2/lib/style.css";
import { ShimmerThumbnail } from "react-shimmer-effects";
import "./Recon.css";
import * as XLSX from "xlsx";
import { createRecon } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import { getTransactionThroughOrderId } from "../../../config/LiveApi";
import TransactionTable from "./TransactionTable";
import Spinner from "../../Spin/Spinner";
import { toast } from "react-toastify";

export const signUpSchema = Yup.object({
  amount: Yup.string().required("Please enter Amount"),
  orderId: Yup.string().required("Please enter Order ID"),
  transactionId: Yup.string().required("Please enter transaction ID"),
  userId: Yup.string().required("Please enter User ID"),
});

function ReconForm({
  setShowZyroList,
  setExcelData,
  setShowOurList,
  setAddedDataForRecon,
}) {
  let token = useSelector((store) => store.userReducer.token);
  const [selectedOptions, setSelectedOptions] = useState("");
  const [typeValue, setTypeValue] = useState("");
  const [modeSelected, setModeSelected] = useState("");
  const [modeValue, setModeValue] = useState("");
  const [startLoading, setStartLoading] = useState(false);
  const [totalOptions, setTotalOptions] = useState(null);
  const [excelFile, setExcelFile] = useState(null);
  const [orderId, setOrderId] = useState("");
  const [reconTxns, setReconTxns] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [typeError, setTypeError] = useState(null);

  const initialValues = {
    orderId: "",
    transactionId: "",
    userId: "",
    amount: "",
  };

  // const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
  //   useFormik({
  //     initialValues,
  //     validationSchema: signUpSchema,
  //     onSubmit: (values, action) => {
  //       console.log(
  //         "🚀 ~ file: Registration.jsx ~ line 11 ~ Registration ~ values",
  //         values
  //       );
  //       createRecon(token, {
  //         userId: values.userId,
  //         transactionId: values.transactionId,
  //         createAt: Date.now(),
  //         dataItem: values,
  //       });
  //       action.resetForm();
  //     },
  //   });

  const handleFileChange = (e) => {
    let fileTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv",
    ];
    let selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile && fileTypes.includes(selectedFile.type)) {
        setTypeError(null);
        let reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile);
        reader.onload = (e) => {
          setExcelFile(e.target.result);

          if (e.target.result) {
            const workbook = XLSX.read(e.target.result, { type: "buffer" });
            const worksheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[worksheetName];
            // ✅ Get headers and Validate
            const headers = XLSX.utils.sheet_to_json(worksheet, {
              header: 1,
            })[0];

            if (!headers || headers[0] !== "RRN") {
              toast.error("Excel must have 'RRN' as the first column header");
              setExcelData([]);
              setShowZyroList(false);
              return;
            }
            const data = XLSX.utils.sheet_to_json(worksheet);
            console.log("data12121212121", data);
            if (data.length > 0) {
              setExcelData(data);
              setShowZyroList(true);
            }

            // handleApiData(data.slice(0, 10));
          }
        };
      } else {
        setTypeError("Please select only excel file types");
        setExcelFile(null);
      }
    } else {
      console.log("Please select your file");
    }
  };

  const fetchTransactions = async (orderId) => {
    if (!orderId || !orderId.trim()) {
      toast.error("Please Enter Valid OrderId");
      return;
    }
    setIsLoading(true);
    setOrderId("");
    const bulkIds = orderId.split(",");

    const allTransactionData = await Promise.all(
      bulkIds.map(async (id) => {
        const txnsData = await getTransactionThroughOrderId(token, id);
        return txnsData.transactionDetail;
      }),
    );

    setIsLoading(false);
    setReconTxns(allTransactionData.flat());
  };

  return (
    <div>
      <div className="out-head">
        <h2 className="area-top-title-pay-out">Chargeback Form</h2>

        <div className="app-container">
          <label htmlFor="file-upload" className="styled-button">
            Bulk Import
          </label>
          <input
            id="file-upload"
            type="file"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
        </div>
      </div>

      {startLoading ? (
        <ShimmerThumbnail height={500} rounded />
      ) : (
        <div className="add-recon">
          <p className="add-recon-text">Enter Order ID:</p>
          <input
            type="text"
            className="add-recon-input"
            value={orderId}
            placeholder="Order Id"
            onChange={(e) => setOrderId(e.target.value)}
          />
          <div className="add-recon-btn-container">
            <button
              className="add-recon-btn"
              onClick={() => fetchTransactions(orderId)}
            >
              Submit
            </button>
          </div>
        </div>
      )}

      {isLoading ? (
        <Spinner />
      ) : (
        reconTxns.length > 0 && (
          <TransactionTable
            reconTxns={reconTxns}
            setShowOurList={setShowOurList}
            setAddedDataForRecon={setAddedDataForRecon}
          />
        )
      )}
    </div>
  );
}

export default ReconForm;
